<template>
  <!--  @click="getPath"放在容器内 -->

  <div
    class="colorBox mColorBox"
    :style="{ backgroundImage: 'url(' + `${bgurl}` + ')' }"
  >
    <div class="frosted-background">
      <!-- 嵌入内容的容器 -->
      <slot content="colorBoxContent" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    bgurl: {
      type: String,
      default: () => {
        return require("@/images/com/fbec_border_bg.png");
      },
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.colorBox {
  width: 13.14rem;
  height: 6.4rem;
  background: no-repeat left top;
  background-size: 100% 100%;
  padding: 0.48rem 0 0 0.5rem;
  .frosted-background {
    width: 12.33rem;
    height: 5.6rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/colorBox.vue